import UndoToastComponent from '@/libs/components/undo-toast/UndoToastComponent.vue';

export type UndoToastComponentRef = InstanceType<typeof  UndoToastComponent>;
export default UndoToastComponent;